import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id 098E9BF3-3E1F-43E3-ACFF-2D35123A3186
 * name less-than
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/less-than.svg
 * tags
 * - Math 
 */
export const LessThanIcon = createSvgIcon(<><path d="M18.5,4.14L19.5,5.86L8.97,12L19.5,18.14L18.5,19.86L5,12L18.5,4.14Z" /></>, 'LessThanIcon');
export default LessThanIcon